import React, { useMemo } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import COUNTRY_PHONE_CODES from 'data/countryPhoneCodes';

const PhoneInput = ({ 
  value = '', 
  onChange, 
  country = '', 
  onCountryChange,
  placeholder = 'Phone number',
  label = 'Phone',
  required = false,
  disabled = false,
  className = ''
}) => {
  const selectedCountry = useMemo(() => {
    if (!country) return null;
    return COUNTRY_PHONE_CODES.find(c => c.name === country);
  }, [country]);

  const countryOptions = useMemo(() => {
    return COUNTRY_PHONE_CODES.map(c => ({
      value: c.name,
      label: `${c.flag} ${c.phone} - ${c.name}`
    }));
  }, []);

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;
    onChange?.(newValue);
  };

  const handleCountrySelect = (option) => {
    onCountryChange?.(option?.value || '');
  };

  const selectedOption = useMemo(() => {
    if (!country) return null;
    return countryOptions.find(opt => opt.value === country);
  }, [country, countryOptions]);

  return (
    <Form.Group className={className}>
      {label && <Form.Label>{label}{required && ' *'}</Form.Label>}
      <InputGroup>
        <div style={{ flex: '0 0 200px', minWidth: '200px' }}>
          <Select
            options={countryOptions}
            value={selectedOption}
            onChange={handleCountrySelect}
            isDisabled={disabled}
            isClearable={false}
            placeholder="Select country..."
            isSearchable={true}
            noOptionsMessage={() => 'No countries found'}
            styles={{
              control: (base) => ({
                ...base,
                borderRadius: '0.375rem'
              })
            }}
          />
        </div>
        <InputGroup.Text>
          {selectedCountry?.flag} {selectedCountry?.phone}
        </InputGroup.Text>
        <Form.Control
          type="tel"
          value={value}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
        />
      </InputGroup>
    </Form.Group>
  );
};

export default PhoneInput;
